import { render, staticRenderFns } from "./UCIrvineADISpecGradingQuizQ7.vue?vue&type=template&id=359e1848&scoped=true&"
import script from "./UCIrvineADISpecGradingQuizQ7.vue?vue&type=script&lang=js&"
export * from "./UCIrvineADISpecGradingQuizQ7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e1848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VRadio,VRadioGroup,VSelect})
